<template>
  <div>
    <el-menu
      class="el-menu-demo"
      mode="horizontal"
      background-color="#fff"
      text-color="#000"
      active-text-color="#000"
    >
      <div class="menu_top">
        <div class="left_box">
          <div>
            <el-button class="buttonimg">
              <i
                class="showimg"
                :class="collapsed ? 'el-icon-s-fold' : 'el-icon-s-unfold'"
                @click="toggle(collapsed)"
              ></i>
            </el-button>
          </div>
          <div v-if="screenWidth">
            <record></record>
          </div>
        </div>
        <div class="right_box">
            <el-row type="flex" justify="end"  style="padding: 0 40px;  background: #fff;border-radius: 10px;">
<!--              <el-col :span="10">-->
                <el-select style="width: 100%;" size="mini"  placeholder="运营商" v-model="operatorId"  @change="handleChangeOperator">
                  <el-option v-for="item in operatorForSelect" :key="item.operatorId" v-bind:label="item.operatorName"
                             v-bind:value="item.operatorId" ></el-option>
                </el-select>
<!--              </el-col>-->
<!--              <el-col :span="10">
                <el-select size="mini" style="width:150px;" placeholder="所属站" v-model="stationCode" @change="getStation" >
                  <el-option v-for="item in stationsForSelect" :key="item.id" v-bind:label="item.stationName"
                             v-bind:value="item.stationCode"  ></el-option>
                </el-select>
              </el-col>-->
            </el-row>
          <div>
            <el-tooltip
              content="全屏缩放"
              effect="dark"
              placement="bottom"
              fullscreen
            >
              <img class="qp_img" :src="imgqp" @click="isScreenFull" />
            </el-tooltip>
          </div>
          <div class="right-bread">
            <el-dropdown @command="clickDropdown">
              <span class="el-dropdown-link">
                <!-- <img class="my_img" :src="imgmy"> -->
                {{ userNickName }}
                <img class="my_img" :src="imgmy" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="1">设置</el-dropdown-item>
                <el-dropdown-item command="2">退出</el-dropdown-item>
<!--                <el-dropdown-item command="3">v1.0.0</el-dropdown-item>-->
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <!-- <template slot="title">{{ platformTitle }}</template> -->
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import record from "./record";
//引入全屏插件
import screenfull from "screenfull";
import operatingViewOperatorApi from "../module/monitoringCenter/api/operatingViewOperatorApi";
import comApi from "@/common/api/commonApi.js";

export default {
  name: "topheader",
  data() {
    return {
      collapsed: true,
      imgmy: require("../assets/img/my.png"),
      imgqp: require("../assets/img/qp.png"),
      screenWidth: true,
      operatorForSelect: [],
      stationCode: '',
      stationsForSelect:[],
      operatorId:'',
      customerId:''
    };
  },
  components: {
    record,
  },
  computed: {
    ...mapGetters(["nickname", "realName", "platformName"]),
    userNickName: {
      get() {
        return this.realName || this.nickname;
      },
    },
    platformTitle: {
      get() {
        return this.platformName ? this.platformName : "充小兽合伙人管理平台";
      },
    },
  },

  watch: {
    'operatorId': {
      handler: function (type) {
        if(!type){
          this.toLogin()
        }
      }
    }
  },

  // 创建完毕状态(里面是操作)
  created() {
    // 监听窗口改变后改变
    this.$root.Bus.$on("screenWidth", (value) => {
      this.screenWidth = value < 1400 ? false : true;
      if (value <= 1400) {
        this.toggle(true);
      }
    });
    this.operatorForSelect = JSON.parse(sessionStorage.getItem("operatorForSelect"))
    //this.stationsForSelect = JSON.parse(sessionStorage.getItem("stationsForSelect"))
    this.operatorId = sessionStorage.getItem('operatorId')
   // this.stationCode = sessionStorage.getItem('stationCode')
   // this.customerId=sessionStorage.getItem('customerId')
  },
  methods: {

    toLogin() {
      this.$store.dispatch('user/deleteUserInfo', this.nickname)
        .finally(async () => {
          await this.$store.dispatch('user/resetToken')
          this.$router.push({path: '/login'})
        })
    },


    //全屏方法
    isScreenFull() {
      // 需要注意的是 如果判断!screenfull.enabled 显示的是不支持全屏的话 是因为谷歌的版本问题  判断改为 !screenfull.isEnabled  就可以了

      if (!screenfull.isEnabled) {
        // 如果不支持进入全屏，发出不支持提示
        this.$message({
          message: "您的浏览器版本过低不支持全屏显示！",
          type: "warning",
        });
        return false;
      }
      screenfull.toggle();
    },

    clickDropdown(command) {
      switch (command) {
        case "1":
          this.toSetting();
          break;
        case "2":
          this.exit();
          break;
      }
    },
    toSetting() {
      this.$router.push({ name: "personalSettings" });
    },
    // 退出登录
    exit() {
      this.$confirm("退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(async () => {
          try {
            await this.$store.dispatch("user/deleteUserInfo", this.nickname);
          } finally {
            await this.$store.dispatch("user/logout");
            // 刷新页面
            location.reload();
          }
        })
        .catch(() => {});
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype;
      this.$root.Bus.$emit("toggle", this.collapsed);
    },
    handleChangeOperator(e) {
      /*let parameter ='userId='+this.customerId + '&operatorId=' + e
      this.stationCode = ''
      comApi.searchList(parameter).then((res) => {
          this.stationsForSelect = res.data[0].stations
        })*/
      //存放运营商信息
      sessionStorage.setItem("operatorForSelect", JSON.stringify(this.operatorForSelect));
    //  sessionStorage.setItem("stationsForSelect", JSON.stringify(this.stationsForSelect));
      sessionStorage.setItem("operatorId",this.operatorId)
      this.$store.commit("operatorId",this.operatorId)
    },
    getStation(e){
      this.stationCode = e
      sessionStorage.setItem("operatorForSelect", JSON.stringify(this.operatorForSelect));
      sessionStorage.setItem("stationsForSelect", JSON.stringify(this.stationsForSelect));
      sessionStorage.setItem("operatorId",this.operatorId)
      sessionStorage.setItem("stationCode",this.stationCode)
      this.$store.commit("setStationCode",this.stationCode)
      this.$store.commit("operatorId",this.operatorId)
    }
  },
};
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  height: 50px;
}

.el-dropdown-link {
  font-size: 16px;
  color: #252525;
  cursor: pointer;
}

.menu_top,
.left_box {
  height: 50px;
  position: relative;
  display: flex;
  justify-content: space-between;
}

.right_box {
  display: flex;
  height: 50px;
  line-height: 50px;
}

.right_box > div {
  padding: 0 20px 0 0;
}

.my_img {
  background-color: #c0c4cc;
  width: 20px;
  height: 20px;
  padding: 5px;
  border-radius: 50%;
  transform: translateY(8px);
  margin-left: 5px;
}

.qp_img {
  width: 20px;
  height: 20px;
  vertical-align: middle;
  cursor: pointer;
}

/deep/ .el-submenu__title {
  height: 50px;
}

.buttonimg {
  height: 50px !important;
  border: none;
  padding: 0 10px;
  font-size: 20px;
}

.showimg:active {
  border: none;
}

.el-menu.el-menu--horizontal {
  border-bottom: 0px;
  z-index: 999;
}

.topSpan {
  display: inline-block;
  float: left;
  text-align: left;
  padding-left: 15px;
  color: white;
  font-size: 20px;
  height: 50px;
  line-height: 50px;
}

.topSpan:focus {
  outline: none;
}

.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid transparent;
  color: #fff;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/topheader.vue